import { PenaltyCalculator } from '../PenaltyCalculator';
import { Section } from './styles';

interface ClaimPenaltySectionProps {
  amount?: number | null;
}

export function ClaimPenaltySection({ amount }: ClaimPenaltySectionProps) {
  return (
    <Section>
      <h4>Калькулятор неустойки / ст.395 ГК</h4>
      <PenaltyCalculator defaultPrincipal={amount ?? undefined} embedded />
    </Section>
  );
}
